import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '@/core/api/request-builder';
import { StrictHttpResponse } from '@/core/api/strict-http-response';
import { PcmsoCreateRequest, PcmsoRequest } from '@/core/api/sicom-api/registro/medico/pcmso/pcmso.model';
import { SICOM_PATHS } from 'src/sicom-paths';

/**
 * Insert de PCMSO do Médico (MEDICO_PCMSO)
 * Segue o padrão de funções em `api/` usando RequestBuilder.
 */
export function postPcmso(http: HttpClient, rootUrl: string, body: PcmsoCreateRequest, context?: HttpContext): Observable<StrictHttpResponse<PcmsoRequest>> {
    const rb = new RequestBuilder(rootUrl, postPcmso.PATH, 'post');
    if (body) {
        rb.body(body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>): StrictHttpResponse<PcmsoRequest> => r as unknown as StrictHttpResponse<PcmsoRequest>)
    );
}

postPcmso.PATH = SICOM_PATHS.registro.medico.pcmso.base;
